export default __webpack_public_path__ + "static/media/after-cf@2x.cbc752a4.png";